import template from './_error.pug'

export default {
  template: template(),
  props: {
    error: {
      type: String
    }
  },
  computed: {
    allowedErrors() {
      return [
        'invalid_balance', 'has_registered_tnes', 'has_pending_transactions', 'has_support_item'
      ]
    },

    currentError() {
      return this.allowedErrors.includes(this.error) ? this.error : 'default'
    },

    title() {
      return this.getText(`disableMedia.error.${this.currentError}.title`)
    },

    subtitle() {
      return this.getText(`disableMedia.error.${this.currentError}.subtitle`)
    },

    description() {
      return this.getText(`disableMedia.error.${this.currentError}.description`)
    }
  },
  methods: {
    getText(text) {
      return this.$te(text) ? this.$t(text) : null
    }
  }
}
